import React from 'react';
import { document, policySearchRequest } from '~/api';

export const SectionHeader = ({ colSpan, children }) => (
    <React.Fragment>
        <div className={`col-span-${colSpan}`} />
        <p className={`font-semibold col-span-${colSpan}`}>{children}</p>
    </React.Fragment>
);

export const PolicySearchRequestStatus = Object.freeze({
    New: 1,
    InProgress: 2,
    Review: 5,
    Found: 3,
    NotFound: 4,
    isComplete: (s) => [3, 4].includes(s)
});

export const attachFile = (requestId, docType) => async (file) => {
    const result = await document.upload(file);

    if (!result.success) {
        // TODO: Replace alert with a proper UI error message.
        alert('Document upload failed. Please try again.');
        throw new Error(result.message);
    }

    const attachment = { ...file.uploadInfo, typeId: docType };
    await policySearchRequest.addAttachment(requestId, attachment);
};